import { MeasurementStatisticGroupContainer } from "../containers/MeasurementGroupStatistic"

export const MeasurementStatisticGroupPage = () => (
    <MeasurementStatisticGroupContainer/>
)